"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FirmwareUpdateRequestT = exports.FirmwareUpdateRequest = void 0;
const flatbuffers = __importStar(require("flatbuffers"));
const firmware_update_method_js_1 = require("../../solarxr-protocol/rpc/firmware-update-method.js");
class FirmwareUpdateRequest {
    constructor() {
        this.bb = null;
        this.bb_pos = 0;
    }
    __init(i, bb) {
        this.bb_pos = i;
        this.bb = bb;
        return this;
    }
    static getRootAsFirmwareUpdateRequest(bb, obj) {
        return (obj || new FirmwareUpdateRequest()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    static getSizePrefixedRootAsFirmwareUpdateRequest(bb, obj) {
        bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
        return (obj || new FirmwareUpdateRequest()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    methodType() {
        const offset = this.bb.__offset(this.bb_pos, 4);
        return offset ? this.bb.readUint8(this.bb_pos + offset) : firmware_update_method_js_1.FirmwareUpdateMethod.NONE;
    }
    method(obj) {
        const offset = this.bb.__offset(this.bb_pos, 6);
        return offset ? this.bb.__union(obj, this.bb_pos + offset) : null;
    }
    static startFirmwareUpdateRequest(builder) {
        builder.startObject(2);
    }
    static addMethodType(builder, methodType) {
        builder.addFieldInt8(0, methodType, firmware_update_method_js_1.FirmwareUpdateMethod.NONE);
    }
    static addMethod(builder, methodOffset) {
        builder.addFieldOffset(1, methodOffset, 0);
    }
    static endFirmwareUpdateRequest(builder) {
        const offset = builder.endObject();
        return offset;
    }
    static createFirmwareUpdateRequest(builder, methodType, methodOffset) {
        FirmwareUpdateRequest.startFirmwareUpdateRequest(builder);
        FirmwareUpdateRequest.addMethodType(builder, methodType);
        FirmwareUpdateRequest.addMethod(builder, methodOffset);
        return FirmwareUpdateRequest.endFirmwareUpdateRequest(builder);
    }
    unpack() {
        return new FirmwareUpdateRequestT(this.methodType(), (() => {
            const temp = (0, firmware_update_method_js_1.unionToFirmwareUpdateMethod)(this.methodType(), this.method.bind(this));
            if (temp === null) {
                return null;
            }
            return temp.unpack();
        })());
    }
    unpackTo(_o) {
        _o.methodType = this.methodType();
        _o.method = (() => {
            const temp = (0, firmware_update_method_js_1.unionToFirmwareUpdateMethod)(this.methodType(), this.method.bind(this));
            if (temp === null) {
                return null;
            }
            return temp.unpack();
        })();
    }
}
exports.FirmwareUpdateRequest = FirmwareUpdateRequest;
class FirmwareUpdateRequestT {
    constructor(methodType = firmware_update_method_js_1.FirmwareUpdateMethod.NONE, method = null) {
        this.methodType = methodType;
        this.method = method;
    }
    pack(builder) {
        const method = builder.createObjectOffset(this.method);
        return FirmwareUpdateRequest.createFirmwareUpdateRequest(builder, this.methodType, method);
    }
}
exports.FirmwareUpdateRequestT = FirmwareUpdateRequestT;
